import type { SecureState } from '../../types/state'
import { GatedDisplayModes } from '../constants/enums'

/**
 * Whether an age-gated visitor gets AgeGatedPosterImage instead of a
 * player. As on www (misc.MfcJs MfcClientVideo.js) a region with a site
 * preview plays every model in the SDK's ACR mode (blurred, live audio
 * blocked, her video avatars first, see decideACR); a `no_video` preview
 * gets live snaps, and a region without one never reaches a room.
 */
export const showsAgeGatedPoster = (
    ageGateActive: boolean | undefined,
    displayConfig: SecureState['displayConfig'],
) =>
    !!ageGateActive &&
    (displayConfig?.settings !== GatedDisplayModes.preview ||
        !!displayConfig.noVideo)
